// dependency on external js: flickity.pkgd.js

import {
  slider
  // hoverNav,
  // orientation // don't need this  don't think
} from '../slider/index';



export function slideshow($block, isadmin) {

  var $ = $ || jQuery; // added to see solve jquery issue

  console.log("slideshow admin", $block, isadmin);

  if (isadmin == true) {
    console.log("admin == true:", isadmin);
  } else {
    console.log("admin == false:", isadmin);
  };


  console.log("slideshow block", $block);

  // pass block into this:

  var container = $block[0];

  // SliderContainerEl = container.querySelector(".slider__container");

  console.log("container", container);

  slider(container);


} //export function slideshow($block){